module.exports = __webpack_public_path__ + "static/media/1.269cb46d.JPG";